import type { FaireProductEntity } from "../../entity_types/product";

export const p_6gw9wr3wv9: FaireProductEntity = {
  token: "p_6gw9wr3wv9",
  type: "product",
  name: "Bloom Makeup Kit",
  brandToken: "b_32jb4m2ybn",
  brandName: "True Bloom",
  imageUrl:
    "https://cdn.faire.com/fastly/a5d7c093b1374f3ea8d459f38841c704477698e5b22c4e636a5dd05bc57a6c7c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8d030c072a5712292f6f145e07df6c9f916f97b788302b35c217337313262fa1.jpeg",
    "https://cdn.faire.com/fastly/5f1265c93e174626d1734ad4f7c69323578adf555edcd05cac9326f9460e02a8.png",
    "https://cdn.faire.com/fastly/56d68083e5d7a09e8ec9ad6148d98a58973f8b4441cf99d9ada8804b594571e6.jpeg",
    "https://cdn.faire.com/fastly/e86dc2ddd8980ad07f0ccd1ca6357618173272ef143e47a64f88df0c2fe588bf.jpeg",
    "https://cdn.faire.com/fastly/a046d763f6b0eddbad65f62b6359590d0f3391a93c8207dcb8bc6494ae25b216.jpeg",
    "https://cdn.faire.com/fastly/09ff2ccd0ecba747d62d5d8e576fc75710ebd924ace0daa8114a8bc8a55240fa.jpeg",
    "https://cdn.faire.com/fastly/0111dfdf3871cd67880258c92f22258734f0527b7f8e367dba1af133d1e947ae.jpeg",
    "https://cdn.faire.com/fastly/41d17b1be5c283150331b3fe35bbd140f9a4ea21aec32565c6a086cbd5155646.jpeg",
    "https://cdn.faire.com/fastly/a3f41dbf6d325c9798cf9f5a376b338f0d5467f686c3f40e5c0da07221895a3e.jpeg",
  ],
  priceDollars: 28.5,
  description:
    "\nKit Includes:\n\nBloom bag with wipeable interior \n\nBamboo compact case\n\nFour magnetic eye shadow pans\n\nOne magnetic blush pan\n\nOne bamboo blush brush \n\nOne bamboo eye shadow brush\n\nBamboo lip gloss tube\n\nOne durable and waterproof sticker\n",
  tags: [],
  msrpDollars: 57,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:04.514Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
